import { alertActions } from '../constants/actionTypes/alertActionTypes';

export const clearAlert = () => {
	return {
		type: alertActions.CLEAR_ALERT
	};
};